(function () {
  'use strict';

  const cache = {};
  let running = false;
  let observer = null;
  let everFound = false;

  function formatMoney(cents) {
    cents = parseInt(String(cents).replace('.', ''), 10);
    if (window.Shopify && window.Shopify.formatMoney) {
      const fmt = window.Shopify.moneyFormat || window.theme?.moneyFormat || '{{amount}}';
      return window.Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toLocaleString('tr-TR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'TRY',
    });
  }

  async function getProduct(handle) {
    if (cache[handle] !== undefined) return cache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      cache[handle] = res.ok ? await res.json() : null;
    } catch {
      cache[handle] = null;
    }
    return cache[handle];
  }

  async function injectUnitPrices() {
    if (running) return;
    const nodes = document.querySelectorAll(
      '.boost-sd__product-unit-price:not([data-loaded])'
    );
    if (!nodes.length) return;

    everFound = true;
    running = true;
    try {
      const handles = [...new Set([...nodes].map((el) => el.dataset.handle))].filter(Boolean);

      await Promise.all(
        handles.map(async (handle) => {
          const product = await getProduct(handle);
          if (!product) return;

          const variant = product.variants.find(
            (v) => v.unit_price_measurement != null
          );
          if (!variant) return;

          const { unit_price, unit_price_measurement: upm } = variant;
          const priceFormatted = formatMoney(unit_price);
          const ref =
            upm.reference_value === 1
              ? upm.reference_unit
              : `${upm.reference_value} ${upm.reference_unit}`;

          const html = `<div class="unit-price">
            <span class="unit-price__price">${priceFormatted}</span>
            <span class="unit-price__separator">/</span>
            <span class="unit-price__unit">${ref}</span>
          </div>`;

          document
            .querySelectorAll(`.boost-sd__product-unit-price[data-handle="${handle}"]`)
            .forEach((el) => {
              el.innerHTML = html;
              el.setAttribute('data-loaded', 'true');
            });
        })
      );
    } finally {
      running = false;
    }
  }

  // debounce: Boost render sirasinda yuzlerce mutation yerine tek calistirma
  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  // --- Ilk yukleme ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectUnitPrices);
  } else {
    injectUnitPrices();
  }

  // --- Boost render'lari icin observer (kalici olarak body'de) ---
  // NOT: Boost filtre/sayfalama sirasinda urun listesi konteynerini komple
  // yeniden olusturdugu icin observer'i konteynere daraltmiyoruz —
  // daraltilmis observer detached node'u izleyip kor kaliyordu.
  observer = new MutationObserver(debounce(injectUnitPrices, 200));
  observer.observe(document.body, { childList: true, subtree: true });

  // Boost elementi olmayan sayfalarda (urun, ana sayfa) 20 sn sonra tamamen birak
  setTimeout(function () {
    if (!everFound && observer) {
      observer.disconnect();
      observer = null;
    }
  }, 20000);

  // Boost'un resmi hook'lari - varsa ek guvence
  let tries = 0;
  (function registerBoostHook() {
    const bwi = window.boostWidgetIntegration;
    if (bwi && typeof bwi.regisCustomization === 'function') {
      bwi.regisCustomization(injectUnitPrices, 'filter');
      bwi.regisCustomization(injectUnitPrices, 'pagination');
      return;
    }
    if (++tries <= 50) setTimeout(registerBoostHook, 100);
  })();
})();